<template>
	<div class="card card-reserved">
		<div class="card-section-top" v-if="remainingSpots > 0">
			<div class="row">
				<div class="col-xs-12 col-sm-4 m-b-grid"><strong>{{ remainingSpots }}</strong> spot<span v-if="remainingSpots !== 1">s</span> available</div>
				<div class="col-xs-12 col-sm-8 m-b-grid text-sm-right key" aria-hidden="true">

					<span class="key-item">Key:</span>
					<br class="hidden-sm-up">

					<span class="key-item">
						<svg width="18" height="18" viewBox="0 0 18 18" class="key-item-svg">
							<g class="svg-spot-selected">
								<circle class="svg-spot-circle" stroke-miterlimit="10" cx="9" cy="9" r="8" stroke-width="2"/>
							</g>
						</svg>
						Current Spot<span v-if="selectedSpots.length > 1">s</span>
					</span>

					<span class="key-item">
						<svg width="18" height="18" viewBox="0 0 18 18" class="key-item-svg">
							<g class="">
								<circle class="svg-spot-circle" stroke-miterlimit="10" cx="9" cy="9" r="8" stroke-width="2"/>
							</g>
						</svg>
						Available
					</span>

					<span class="key-item">
						<svg width="18" height="18" viewBox="0 0 18 18" class="key-item-svg">
							<g class="svg-spot-unavailable">
								<circle class="svg-spot-circle" stroke-miterlimit="10" cx="9" cy="9" r="8" stroke-width="2"/>
							</g>
						</svg>
						Unavailable
					</span>

				</div>
				<div class="col-xs-12 m-b-grid" v-if="selectedSpots">Spot<span v-if="selectedSpots.length > 1">s</span> {{ selectedSpots.join(' and ') }} <span v-if="selectedSpots.length == 1">is</span><span v-else>are</span>  selected.</div>
			</div>
			<div class="text-xs-center">
				<svg width="86" height="86" viewBox="0 0 86 86" class="instructor-display-image">
					<g transform="translate(-5157 -1246)">
						<g id="Ellipse_56" transform="translate(5157 1246)" class="instructor-display-image-outer-circle" stroke-width="2">
							<circle cx="43" cy="43" r="43" stroke="none"/>
							<circle cx="43" cy="43" r="42" fill="none"/>
						</g>
						<g transform="translate(0 -93)">
							<circle cx="35" cy="35" r="35" transform="translate(5165 1347)" class="instructor-display-image-inner-circle"/>
							<path d="M3574-5315.777V-5322a13,13,0,0,1,13-13h18a13,13,0,0,1,13,13v6.222a34.852,34.852,0,0,1-22,7.777A34.858,34.858,0,0,1,3574-5315.777Z" transform="translate(1604 6725)" class="instructor-display-image-body"/>
							<rect width="15" height="25" rx="7.5" transform="translate(5193 1357)" class="instructor-display-image-head"/>
						</g>
					</g>
				</svg>
				<p class="instructor-display-name" aria-hidden="true">Instructor<br><span v-html="instructorName"></span></p>
			</div>
		</div>

		<div class="card-section" v-if="spots.length && remainingSpots > 0">
			<div class="card-section-cell spot-map" :class="{ 'spot-change-mode' : isEditing }">
				<svg :viewBox="svgViewBoxString" aria-hidden="true" preserveAspectRatio="xMidYMin slice" :style="ieSvgStyles">
					<rect fill="none" x="-4.5" y="-4.5" :width="svgViewBoxMaxX" :height="svgViewBoxMaxY"/>
					<g v-for="spot in spots" :key="spot.key" class="svg-spot" :class="{'svg-spot-unavailable': spot.isTaken, 'svg-spot-pending': spot.isPending, 'svg-spot-selected': spot.isSelected || spot.isPending}" :data-testid="getSpotDataTest(spot)" @click="selectSpot(spot)" :title="getSpotTooltip(spot)" :data-original-title="getSpotTooltip(spot)" data-placement="right">
						<circle class="svg-spot-circle" stroke-miterlimit="10" :cx="spot.x" :cy="spot.y/layoutAspectRatio" :r="svgSpotRadius" :stroke-width="svgSpotStrokeWidth"/>
						<text class="svg-spot-text" :x="spot.x" :y="spot.y/layoutAspectRatio" text-anchor="middle" dy="1.4" style="font-size: 4px; font-weight: bold;">{{ getSpotLabel(spot) }}</text>
					</g>
				</svg>

				<select v-model="editSpot" :disabled="!editSpot" class="c-select m-t-grid center-block hidden-sm-up" @change="selectSpotDropdown()" aria-label="edit spot">
					<option v-for="spot in spots" :value="spot.key" :key="spot.key" :disabled="spot.isTaken && spot.memberId !== selectingFor.memberId">
						Spot {{ spot.key }}
					</option>
				</select>

			</div>
		</div>
	</div>


</template>

<script>
import _ from 'lodash';
import Vue, { defineComponent } from 'vue';

export default defineComponent({
	name: 'PickASpotSub',
	props: {
		spots: {
			default: () => [],
			type: Array
		},
		layoutAspectRatio: {
			default: 1,
			type: Number
		},
		participants: {
			default: () => [],
			type: Array
		},
		instructorName: {
			default: '',
			type: String
		}
	},
	data() {
		return {
			svgSpotRadius: 4,
			svgSpotStrokeWidth: 0.5,
			selectingFor: {},
			remainingSpots: 0,
			selectedSpots: [],
			editSpot: '',
			isEditing: false
		};
	},
	computed: {
		svgViewBoxMinX: function() {
			return -(this.svgSpotRadius + this.svgSpotStrokeWidth);
		},
		svgViewBoxMinY: function() {
			return -(this.svgSpotRadius + this.svgSpotStrokeWidth);
		},
		svgViewBoxMaxX: function() {
			return 100 + 2 * (this.svgSpotRadius + this.svgSpotStrokeWidth);
		},
		svgViewBoxMaxY: function() {
			return 100 / this.layoutAspectRatio + 2 * (this.svgSpotRadius + this.svgSpotStrokeWidth);
		},
		svgViewBoxString: function() {
			return `${this.svgViewBoxMinX} ${this.svgViewBoxMinY} ${this.svgViewBoxMaxX} ${this.svgViewBoxMaxY}`;
		},
		ieSvgStyles: function() {
			// Hack for IE 11 SVG scaling issues
			return /Trident.*rv[ :]*11\./.test(navigator.userAgent) ? `width: 100%; padding-bottom: ${100 * this.svgViewBoxMaxY / this.svgViewBoxMaxX}%; height: 1px;` : '';
		}
	},
	mounted() {
		this.selectedSpots = _.map(_.filter(this.spots, { 'isSelected': true }), (s) => s.key);
		this.remainingSpots = _.filter(this.spots, { 'isTaken': false }).length + this.selectedSpots.length;

		setTimeout(() => {
			$('.spot-map .svg-spot').myltTooltip();
		});

		this.$parent.$on('edit-participant-spot', this.editParticipantSpot);
	},
	methods: {
		getSpotLabel(spot) {
			let member = this.participants.find(p => p.memberId === spot.memberId);
			return member ? (member.firstName.substr(0, 1) + (member.lastName? member.lastName.substr(0, 1) : '')).toUpperCase() : spot.key;
		},
		getSpotTooltip(spot) {
			const member = this.participants.find(p => p.memberId === spot.memberId);
			const memberName = member ? member.firstName : '';
			return memberName ? `${memberName} (Spot ${spot.key})` : '';
		},
		getSpotDataTest(spot) {
			if (spot.isSelected) return 'spotSelected';
			else if (spot.isTaken) return 'spotTaken';
			else return 'spotAvailable';
		},
		editParticipantSpot(participant) {
			this.isEditing = true;
			this.editSpot = participant.spot;
			this.selectingFor.memberId = participant.memberId;
		},
		selectSpot(spot) {
			if (this.isEditing && !spot.isTaken) {
				Vue.set(spot, 'isPending', true); // Highlight spot until API request goes through
				this.$emit('spot-changed', { spot: spot.key, memberId: this.selectingFor.memberId });
			}
		},
		selectSpotDropdown() {
			const spot = this.spots.find(s => s.key === this.editSpot);
			Vue.set(spot, 'isPending', true); // Highlight spot until API request goes through
			this.$emit('spot-changed', { spot: this.editSpot, memberId: this.selectingFor.memberId });
		},
		setSelectedSpot(spotKey) {
			this.isEditing = false;
			this.editSpot = '';

			const oldSpot = this.spots.find(s => s.memberId === this.selectingFor.memberId);
			if (oldSpot) {
				oldSpot.isTaken = false;
				oldSpot.isSelected = false;
				oldSpot.memberId = 0;
			}

			if (!spotKey) return;
			const spot = this.spots.find(s => s.key === spotKey);
			spot.isTaken = true;
			Vue.set(spot, 'isPending', false);
			spot.isSelected = true;
			spot.memberId = this.selectingFor.memberId;

			this.selectedSpots = _.map(_.filter(this.spots, { 'isSelected': true }), (s) => s.key);
		},
		setSpotUnavailable(spotKey) {
			if (!spotKey) return;
			const spot = this.spots.find(s => s.key === spotKey);
			spot.isTaken = true;
			Vue.set(spot, 'isPending', false);
			spot.isSelected = false;
			spot.memberId = -1;
		}
	}
});
</script>

<style lang="scss" scoped>

.key {
	padding-right: 0; // Override grid column padding
}

.key-item {
	white-space: nowrap;
	margin-right: 1rem;
}

.key-item-svg {
	vertical-align: top;
	margin-top: 3px;
}

.instructor-display-image {
	margin-top: $spacer-half;
	width: 12%;
	height: 12%;
	min-width: 60px;
	min-height: 60px;
	max-width: 86px;
	max-height: 86px;
}
.instructor-display-image-outer-circle {
	fill: none;
	stroke: #aaaaaa;
}
.instructor-display-image-inner-circle {
	fill: #e8e8e8;
}
.instructor-display-image-body {
	fill: #aaaaaa;
}
.instructor-display-image-head {
	fill: #aaaaaa;
}

.instructor-display-name {
	font-weight: bold;
	line-height: 1.2;
	@include media-breakpoint-up(md) {
		font-size: 1.25rem;
	}
}

.spot-change-mode .svg-spot {
	cursor: pointer;

	&.svg-spot-unavailable {
		cursor: not-allowed;
	}

	&:not(.svg-spot-selected):not(.svg-spot-unavailable):hover,
	&:not(.svg-spot-selected):not(.svg-spot-unavailable):focus {
		.svg-spot-circle {
			fill: rgba($aqua, 0.25);
		}
	}

	&:not(.svg-spot-selected):not(.svg-spot-unavailable):active .svg-spot-circle,
	&.svg-spot-pending .svg-spot-circle {
		fill: rgba($aqua, 0.5);
	}
}

.svg-spot-circle {
	fill: $white;
	stroke: $aqua;
	transition: fill 200ms linear;

	.svg-spot-unavailable & {
		fill: $gray-9;
		stroke: $gray-9;
	}

	.svg-spot-selected & {
		fill: $aqua;
		stroke: $aqua;
	}
}

.svg-spot-text {
	fill: $aqua-darker;
	user-select: none;
	transition: fill 200ms linear;

	.svg-spot-unavailable & {
		fill: $gray-5;
	}

	.svg-spot-selected & {
		fill: $white;
	}
}

html[data-whatinput="keyboard"] select {
	display: block !important;
}

.spot-selected-display {
	font-size: 3.75rem;
	font-weight: 500;
	line-height: 1.2;
}

</style>
